import { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import "../styles/certificate.css";
import green from "../images/green.png";
import logo from "../images/logo.png";
import signature from "../images/singature.png";
import api from "./api";
import jalaali from "jalaali-js";
import CertificateQR from "./CertificateQR";
import { useParams } from "react-router-dom";

const Certificate = () => {
  const certRef = useRef();
  const [certificateData, setCertificateData] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    api
      .get("pre_student/api/v3/pre-student/certificates/")
      .then((res) => {
        if (res.data && res.data.certificates && Array.isArray(res.data.certificates)) {
          const withCert = res.data.certificates.find((item) => item.certificate_file !== null);
          if (withCert) {
            setCertificateData(withCert);
          } else {
            console.warn("No valid certificate found in response");
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching certificate data:", err);
      });
  }, []);

  useEffect(() => {
    api.get("pre_student/api/v3/pre-student/certificates/")
      .then((res) => {
        if (res.data && res.data.certificates && Array.isArray(res.data.certificates)) {
          const targetCert = res.data.certificates.find(
            (item) => item.id === id
          );

          if (targetCert) {
            setCertificateData(targetCert);
          } else {
            console.error("مدرکی با این مشخصات پیدا نشد");
          }
        }
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, [id]);

  useEffect(() => {
    if (certificateData) {
      const timer = setTimeout(() => {
        const element = certRef.current;
        const options = {
          margin: 0,
          filename: "certificate.pdf",
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            scale: 8, useCORS: true
          },
          jsPDF: { unit: "mm", format: [297, 180], orientation: "landscape" },
        };
        html2pdf()
          .set(options)
          .from(element)
          .toPdf()
          .get('pdf')
          .then(pdf => {
            if (pdf.internal.getNumberOfPages() > 1) {
              pdf.deletePage(2);
            }
            pdf.save();
          });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [certificateData]);

  const cert = certificateData;

  return (
    <div className="certificate" ref={certRef}>
      <div className="cert-row">
        <div className="cert-left">
          <div className="green-container">
            <img className="green-img" src={green} alt="decoration" />
          </div>

          <div className="logo-circle">
            <img width={50} height={50} crossOrigin="anonymous" src={logo} alt="logo" />
          </div>
          <div className="qr-code">
            <CertificateQR />
            <div className="ff" style={{ position: "absolute", top: "93%", left: "35.3%" }}>
              {cert?.certificate_auth_code}
            </div>
          </div>
        </div>

        <div className="cert-right">
          <h1 className="cert-title">CERTIFICATE</h1>
          <div className="cert-subtitle">OF ACHIEVEMENT</div>

          <h2 className="cert-name">{cert?.student_full_name_en}</h2>

          <p className="cert-text">
            This certificate is proudly presented to{" "}
            <b>{cert?.student_full_name_en}</b> for successfully completing the{" "}
            <b>{cert?.course_name_en || cert?.course_name}</b> Course
            {["Scratch Programming", "Generative AI For Kids", "Scratch Jr Programming"].includes(cert?.course_name) && cert?.term ? (
              <> - Term <span className="ff">{cert.term}</span> </>
            ) : (
              ""
            )}
            organized by{" "}
            <b style={{ color: "#2BA769" }}>PythonTeek</b>.
            <br />
            The student has demonstrated a performance level of{" "}
            <b>{cert?.level ? cert.level.replaceAll("_", " ") : ""}</b>.
            <br />
           {!["Scratch Programming", "Generative AI For Kids", "Scratch Jr Programming"].includes(cert?.course_name) && (
  <>
    <b>Topics covered: </b>
    {Array.isArray(cert?.topics) && cert.topics.length > 0 ? (
      cert.topics.map((t, index) => (
        <span key={index}>
          {index > 0 && " "}
          ● {t.title}
        </span>
      ))
    ) : "—"}
  </>
)}
          </p>

          <div className="cert-footer">
            <div>
              <div className="label">DATE</div>
              <div className="ff mt-4">
                {(() => {
                  if (!cert?.issued_date) return "";
                  const [y, m, d] = cert.issued_date.split("-").map(Number);

                  if (y < 1600) {
                    const { gy, gm, gd } = jalaali.toGregorian(y, m, d);
                    return `${gy}/${String(gm).padStart(2, "0")}/${String(gd).padStart(2, "0")}`;
                  }

                  return `${y}/${String(m).padStart(2, "0")}/${String(d).padStart(2, "0")}`;
                })()}
              </div>
            </div>

            <div className="p-relative">
              <div className="label">SIGNATURE</div>
              <div className="signature">
                <img src={signature} alt="signature" />
              </div>
              <p className="txt-r">
                Dr. Reza Ghanbari Head of Optimization Laboratory, Faculty of
                Mathematical Science, Ferdowsi University of Mashhad
              </p>
            </div>

            <div className="p-relative">
              <img
                className="logo-cert"
                width={90}
                height={90}
                src={`${cert?.logo_url}`}
                alt="Certificate Logo"
              />

              <svg width="150" height="150" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_2066_187)">
                  <path d="M108.118 14.2715C114.941 8.37297 125.059 8.37297 131.882 14.2715C136.723 18.4561 143.409 19.7859 149.483 17.7723C158.044 14.9341 167.392 18.806 171.439 26.8668C174.31 32.5855 179.977 36.3723 186.359 36.8364C195.355 37.4906 202.509 44.6449 203.164 53.6408C203.628 60.0229 207.415 65.6904 213.133 68.5614C221.194 72.6084 225.066 81.9559 222.228 90.5174C220.214 96.5913 221.544 103.277 225.729 108.118C231.627 114.941 231.627 125.059 225.729 131.882C221.544 136.723 220.214 143.409 222.228 149.483C225.066 158.044 221.194 167.392 213.133 171.439C207.415 174.31 203.628 179.977 203.164 186.359C202.509 195.355 195.355 202.509 186.359 203.164C179.977 203.628 174.31 207.415 171.439 213.133C167.392 221.194 158.044 225.066 149.483 222.228C143.409 220.214 136.723 221.544 131.882 225.729C125.059 231.627 114.941 231.627 108.118 225.729C103.277 221.544 96.5913 220.214 90.5174 222.228C81.9559 225.066 72.6084 221.194 68.5614 213.133C65.6904 207.415 60.0229 203.628 53.6408 203.164C44.6449 202.509 37.4906 195.355 36.8364 186.359C36.3723 179.977 32.5855 174.31 26.8668 171.439C18.806 167.392 14.9341 158.044 17.7723 149.483C19.7859 143.409 18.4561 136.723 14.2715 131.882C8.37297 125.059 8.37297 114.941 14.2715 108.118C18.4561 103.277 19.7859 96.5913 17.7723 90.5174C14.9341 81.9559 18.806 72.6084 26.8668 68.5614C32.5855 65.6904 36.3723 60.0229 36.8364 53.6408C37.4906 44.6449 44.6449 37.4906 53.6408 36.8364C60.0229 36.3723 65.6904 32.5855 68.5614 26.8668C72.6084 18.806 81.9559 14.9341 90.5174 17.7723C96.5913 19.7859 103.277 18.4561 108.118 14.2715Z" fill="#2BA769" />
                </g>
                <g filter="url(#filter1_d_2066_187)">
                  <circle cx="119.999" cy="120" r="83.3568" fill="#9FDEBF" />
                </g>
                <defs>
                  <filter id="filter0_d_2066_187" x="0.847656" y="0.847656" width="238.305" height="238.305" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="4.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2066_187" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2066_187" result="shape" />
                  </filter>
                  <filter id="filter1_d_2066_187" x="24.6426" y="24.6436" width="190.714" height="190.713" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2066_187" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="8" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2066_187" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2066_187" result="shape" />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>

          <div className="cert-bottom">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5625 12.5C1.5625 15.4008..."
                stroke="#2BA769"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
            </svg>
            <svg width="20" height="20" className="mb-1" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5625 12.5C1.5625 15.4008 2.71484 18.1828 4.76602 20.234C6.8172 22.2852 9.59919 23.4375 12.5 23.4375C15.4008 23.4375 18.1828 22.2852 20.234 20.234C22.2852 18.1828 23.4375 15.4008 23.4375 12.5C23.4375 9.59919 22.2852 6.8172 20.234 4.76602C18.1828 2.71484 15.4008 1.5625 12.5 1.5625C9.59919 1.5625 6.8172 2.71484 4.76602 4.76602C2.71484 6.8172 1.5625 9.59919 1.5625 12.5Z" stroke="#2BA769" stroke-width="1.5" strokeLinejoin="round" />
              <path d="M7.8125 12.5C7.8125 9.59919 8.30636 6.8172 9.18544 4.76602C10.0645 2.71484 11.2568 1.5625 12.5 1.5625C13.7432 1.5625 14.9355 2.71484 15.8146 4.76602C16.6936 6.8172 17.1875 9.59919 17.1875 12.5C17.1875 15.4008 16.6936 18.1828 15.8146 20.234C14.9355 22.2852 13.7432 23.4375 12.5 23.4375C11.2568 23.4375 10.0645 22.2852 9.18544 20.234C8.30636 18.1828 7.8125 15.4008 7.8125 12.5Z" stroke="#2BA769" stroke-width="1.5" strokeLinejoin="round" />
              <path d="M2.34375 16.1457H22.6562M2.34375 8.854H22.6562" stroke="#2BA769" stroke-width="1.5" strokeLinecap="round" />
            </svg>
            <span className="addr">PythonTeek.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;